import { useLayoutEffect, useRef } from 'react';
import type { TextareaHTMLAttributes } from 'react';
import './AutoGrowTextarea.css';

/**
 * 내용 길이에 맞춰 높이가 자동으로 늘어나는 textarea.
 * 스크롤바 대신 영역 자체가 확장되며, disabled(보기 전용)일 때도 전체 내용이 보인다.
 * rows 는 빈 상태의 최소 높이로만 쓰인다.
 */
export function AutoGrowTextarea(props: TextareaHTMLAttributes<HTMLTextAreaElement>) {
  const { className, ...rest } = props;
  const ref = useRef<HTMLTextAreaElement>(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    // scrollHeight 는 border 미포함(box-sizing: border-box 전역) — border 두께 보정
    el.style.height = 'auto';
    const border = el.offsetHeight - el.clientHeight;
    el.style.height = `${el.scrollHeight + border}px`;
  }, [props.value]);

  return (
    <textarea
      ref={ref}
      {...rest}
      className={['wc-autogrow-textarea', className].filter(Boolean).join(' ')}
    />
  );
}
